// extracted by mini-css-extract-plugin
export var clauseRow = "_bd-6";
export var emptyState = "_bd-d";
export var filterContent = "_bd-a";
export var filterGroup = "_bd-1";
export var filterGroupContainer = "_bd-0";
export var nestedGroup = "_bd-2";
export var nestedGroupContent = "_bd-b";
export var nestedGroupDepth1 = "_bd-3";
export var nestedGroupDepth2 = "_bd-4";
export var nestedGroupDepth3 = "_bd-5";
export var nestedGroupEmpty = "_bd-c";
export var operatorAnd = "_bd-8";
export var operatorOr = "_bd-9";
export var operatorToggle = "_bd-7";
export var removeGroupButton = "_bd-e";